import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { CatalogParameterDto } from './models/CatalogParameterDto';
import { CatalogParameterSearchCriteria } from './models/CatalogParameterSearchCriteria';

class CatalogParametersService {
    public getList (criteria: CatalogParameterSearchCriteria) {
        return Http.get<Paged<CatalogParameterDto>>('catalogparameters', criteria);
    }

    public getCatalog () {
        return Http.get<CatalogParameterDto[]>('catalogparameters/catalog');
    }

    public getById (id: string) {
        return Http.get<CatalogParameterDto>('catalogparameters/' + id);
    }

    public create (model: CatalogParameterDto): Promise<string> {
        return Http.post('catalogparameters', model);
    }

    public update (model: CatalogParameterDto) {
        return Http.put('catalogparameters', model);
    }

    public remove (model: CatalogParameterDto) {
        return Http.put('catalogparameters/deactivate', model);
    }
}

export default new CatalogParametersService();
